module.exports = __webpack_public_path__ + "static/media/logoWhite_rLogistics.9bbf5d31.png";